import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../../../utils/mq';
import { useImageComponent, useLinkComponent } from '../../../utils/component';
import type { LinkProps } from '../../../atoms/types';
import { ActionBar } from '../../action-bar';
import Comment from '../../../icons/comment';

export type CardProps = {
  title?: string;
  rating?: number;
  image: { imageId: string; alt: string; extension?: string; title?: string };
  itemLink?: LinkProps;
  isSmall?: boolean;
  nbComments?: number;
};

const Card = styled.div`
  align-self: stretch;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  margin: 0 0 20px;
  max-width: 360px;

  ${mq.lte(
    DEVICE_SIZE.MEDIUM,
    css`
      max-width: 80vw;
    `,
  )}
`;

const CardImage = styled.div`
  border-bottom: solid 1px #ddd;
  border-radius: 6px;
  overflow: hidden;
`;

const CardBody = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px 0;
`;

const CardTitle = styled.div`
  color: var(--title-foreground);
  font-family: var(--theme-typography-primary-font);
  font-size: 26px;
  font-weight: 700;
  line-height: 1.38;
  text-align: center;

  &.mod-small {
    display: -webkit-box;
    font-size: 18px;
    text-align: left;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
`;

const CardActions = styled.div`
  margin-top: auto;
`;

export function SimpleItemProductCard({ title, image, itemLink, isSmall, nbComments }: CardProps) {
  const ImageComponent = useImageComponent();
  const LinkComponent = useLinkComponent();

  const imageProps = {
    ...image,
    mobileWidth: 360,
    mobileHeight: 250,
    desktopWidth: 360,
    desktopHeight: 250,
    disableRadius: true,
  };

  return (
    <Card>
      <CardImage>
        <LinkComponent {...itemLink}>
          <ImageComponent {...imageProps} />
        </LinkComponent>
      </CardImage>
      <CardBody>
        {itemLink && (
          <CardTitle title={title} className={isSmall ? 'mod-small' : ''}>
            <LinkComponent {...itemLink}>{title}</LinkComponent>
          </CardTitle>
        )}
      </CardBody>
      {nbComments > 0 && (
        <CardActions>
          <ActionBar
            actions={[
              {
                icon: <Comment width={22} height={22} color="var(--title-foreground)" />,
                label: `${nbComments} ${nbComments > 1 ? 'commentaires' : 'commentaire'}`,
                small: true,
              },
            ]}
          />
        </CardActions>
      )}
    </Card>
  );
}
